export default {
    courseResult: state => {
        return state.courseResult;
    },
    courseDtlResult: state => {
        return state.courseDtlResult;
    },
}